<template>
  <div id="chartParameterManagerDiv">
    <div v-for="[key, value] in Object.entries(chartParameters)" :key="key"
      style="display: flex; justify-content: space-between; width: 100%;">
      <button @click="removeParameterButtonClick(key)">x</button>
      {{ key }} :
      <input type="text" @input="e => setValue(key, e)" :value="value" />
    </div>
    <div>
      <input type="text" ref="newChartKeyTxtBox" />
      <button @click="addParameterButtonClick">add key</button>
    </div>
  </div>
</template>

<script setup>
import { inject, useTemplateRef } from 'vue';

const newChartKeyTxtBox = useTemplateRef("newChartKeyTxtBox")

const mainChart = inject('mainChart')
const { chartParameters } = mainChart

const setValue = (key, e) => {
  mainChart.setChartParameter(key, e.target.value)
}

const removeParameterButtonClick = (key) => {
  mainChart.setChartParameter(key, null)
}

const addParameterButtonClick = () => {
  const key = newChartKeyTxtBox.value.value
  mainChart.setChartParameter(key, "")
}

</script>
